<section class="py-20
">
  <div class="max-w-6xl px-6 mx-auto md:px-10">
    <div class="grid grid-cols-1 text-center md:grid-cols-3 gap-14 md:gap-10 ">
      <!-- 50+ -->
      <div class="flex flex-col items-center">
        <div
          class="h-30 flex items-center justify-center font-extrabold text-(--color-main) leading-none"
          dir="ltr"
        >
          <span class="text-[72px] md:text-[92px]">45</span>
          <span class="text-[32px] md:text-[50px] ml-1 self-center">+</span>
        </div>

        <h3 class="mt-2 min-h-18 text-white text-[24px] md:text-[30px] font-bold leading-tight">
          مشروع زراعي ناجح
        </h3>

        <p class="mt-2 min-h-7 text-white text-[18px] md:text-[22px] leading-none">منذ 2020</p>
      </div>

      <!-- 12:18% -->
      <div class="flex flex-col items-center">
        <div
          class="h-30 flex items-center justify-center font-extrabold text-(--color-main) leading-none"
          dir="ltr"
        >
          <span class="text-[72px] md:text-[92px]">76</span>
          <span class="text-[40px] md:text-[65px] ml-1 self-center ">%</span>
        </div>

        <h3 class="mt-2 min-h-18 text-white text-[24px] md:text-[30px] font-bold leading-tight">
          العائد السنوي المتوقع
        </h3>

        <p class="mt-2 min-h-7 text-white text-[18px] md:text-[22px] leading-none">
          بعد خصم الرسوم
        </p>
      </div>

      <!-- 800+ -->
      <div class="flex flex-col items-center">
        <div
          class="h-30 flex items-center justify-center font-extrabold text-(--color-main) leading-none"
          dir="ltr"
        >
          <span class="text-[72px] md:text-[92px]">800</span>
          <span class="text-[32px] md:text-[50px] ml-1 self-center">+</span>
        </div>

        <h3 class="mt-2 min-h-18 text-white text-[24px] md:text-[30px] font-bold leading-tight">
          ألف هكتار متعاقدة
        </h3>

        <p class="mt-2 min-h-7 text-white text-[18px] md:text-[22px] leading-none">في أنحاء مصر</p>
      </div>

     
    </div>
  </div>
</section>
